// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   HOW IT WORKS (overwrite)
   - Left cards + right screenshot share EXACT aspect ratio
   - Right dots hang below (don’t affect bottom alignment)
   - Floating preview follows scroll (JS controls transform)
   ========================= */

.hiw {
  background-image: radial-gradient(circle at 1px 1px, rgba(95, 186, 139, 0.14) 1px, transparent 0);
    background-color: rgba(24, 21, 20, 1);
  background-size: 28px 28px;
  width: 100%;
  padding: 96px 0;
}

.hiw__container {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.hiw__header {
  margin-bottom: 40px;
}

.hiw__kicker {
  font-size: 12px;
  letter-spacing: 0.18em;
  font-weight: 700;
  opacity: 0.65;
}

.hiw__title {
  margin: 10px 0 0 0;
  font-size: 48px;
  line-height: 1.05;
  font-weight: 800;
}

.hiw__subtitle {
  margin: 10px 0 0 0;
  font-size: 18px;
  line-height: 1.5;
  opacity: 0.75;
  max-width: 680px;
}

/* equal columns */
.hiw__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 56px;
  align-items: start;
}

/* -------------------------
   LEFT (3 stacked steps)
   ------------------------- */

.hiw__left {
  position: relative;
}

.hiw__rail {
  position: absolute;
  left: 18px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(0, 0, 0, 0.12);
}

.hiw__steps {
  display: flex;
  flex-direction: column;
  gap: 44px;
}

/* IMPORTANT: matches the right screenshot's aspect ratio */
.hiw__step {
  position: relative;
  width: 100%;
  aspect-ratio: var(--hiw-aspect, 16 / 10);

  border: 1px solid rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(10px);
  border-radius: 28px;
  padding: 32px;

  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.10);
  transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;

  display: flex;
  flex-direction: column;
}

.hiw__step--active {
  border-color: rgba(95, 186, 139, 0.45);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.14);
  transform: translateY(-2px);
}

.hiw__dot {
  position: absolute;
  left: 12px;
  top: 38px;
  width: 12px;
  height: 12px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.20);
}

.hiw__dot--on {
  background: rgba(95, 186, 139, 1);
}

.hiw__topline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.hiw__num {
  font-size: 12px;
  letter-spacing: 0.18em;
  font-weight: 800;
  opacity: 0.7;
}

.hiw__line {
  height: 1px;
  flex: 1 1;
  background: rgba(0, 0, 0, 0.10);
}

.hiw__stepTitle {
  margin: 14px 0 0 0;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.1;
}

.hiw__stepBody {
  margin: 14px 0 0 0;
  font-size: 16px;
  line-height: 1.7;
  opacity: 0.78;

  /* pins buttons to bottom and prevents layout jump */
  flex: 1 1;
  overflow: hidden; /* change to auto if you want internal scroll */
}

.hiw__nav {
  margin-top: 18px;
  display: flex;
  gap: 10px;
}

.hiw__btn {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 0.65);
  padding: 10px 14px;
  border-radius: 999px;
  font-size: 13px;
  cursor: pointer;
  transition: background 150ms ease;
}

.hiw__btn:hover {
  background: rgba(0, 0, 0, 0.04);
}

/* -------------------------
   RIGHT (floating preview)
   ------------------------- */

.hiw__right {
  position: relative; /* track for floater */
  align-self: stretch;
  min-height: 100%;
}

.hiw__floater {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;

  will-change: transform;
  transform: translate3d(0, 0, 0);

  /* allow dots to hang below */
  overflow: visible;
}

.hiw__previewWrap {
  position: relative;
}

.hiw__frame {
  width: 100%;
  aspect-ratio: var(--hiw-aspect, 16 / 10);

  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 28px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 26px 90px rgba(0, 0, 0, 0.14);
}

.hiw__imgStage {
  position: relative;
  width: 100%;
  height: 100%;
}

.hiw__img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

/* crossfade stack */
.hiw__imgFade {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 500ms ease;
}

.hiw__imgFade--on {
  opacity: 1;
}

/* dots do NOT affect frame height */
.hiw__dots{
  position: absolute;
  left: 0;
  right: 0;

  top: auto;              /* override */
  bottom: -26px;          /* <-- pushes dots below the frame bottom edge */
  margin: 0;              /* override */

  display: flex;
  justify-content: center;
  gap: 10px;

  pointer-events: auto;
}


.hiw__dotBtn {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.22);
}

.hiw__dotBtn--on {
  background: rgba(95, 186, 139, 1);
}

.darkWrap{
  --darkT: 0; /* 0 -> 1 */
  /* base colors */
  --from: 252, 249, 248;
  --to: 24, 21, 20;

  /* mix channels in CSS (supported in modern browsers) */
  --r: calc((1 - var(--darkT)) * 252 + var(--darkT) * 24);
  --g: calc((1 - var(--darkT)) * 249 + var(--darkT) * 21);
  --b: calc((1 - var(--darkT)) * 248 + var(--darkT) * 20);

  --bg: rgb(var(--r), var(--g), var(--b));
}

/* Apply same background to BOTH sections so the seam never appears */
.darkWrap .fadeSection,
.darkWrap .darkSection{
  background-color: var(--bg);
}


/* -------------------------
   Mobile
   ------------------------- */

@media (max-width: 900px) {
  .hiw__grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .hiw__right {
    display: none;
  }

  .hiw__rail,
  .hiw__dot {
    display: none;
  }

  .hiw__step {
    aspect-ratio: auto;
  }

  .hiw__stepBody {
    overflow: visible;
  }

  .hiw__title {
    font-size: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/howitworks.css"],"names":[],"mappings":"AAAA;;;;;8BAK8B;;AAE9B;EACE,iGAAiG;IAC/F,qCAAqC;EACvC,0BAA0B;EAC1B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;8BAE8B;;AAE9B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,WAAW;EACX,wCAAwC;;EAExC,qCAAqC;EACrC,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;;EAEb,2CAA2C;EAC3C,gFAAgF;;EAEhF,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,SAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;;EAEb,oDAAoD;EACpD,SAAO;EACP,gBAAgB,EAAE,+CAA+C;AACnE;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;8BAE8B;;AAE9B;EACE,kBAAkB,EAAE,sBAAsB;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;;EAEN,sBAAsB;EACtB,+BAA+B;;EAE/B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wCAAwC;;EAExC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;;EAER,SAAS,eAAe,aAAa;EACrC,aAAa,WAAW,gDAAgD;EACxE,SAAS,eAAe,aAAa;;EAErC,aAAa;EACb,uBAAuB;EACvB,SAAS;;EAET,oBAAoB;AACtB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU,EAAE,WAAW;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;;EAEhB,uDAAuD;EACvD,uDAAuD;EACvD,uDAAuD;EACvD,uDAAuD;;EAEvD,uCAAuC;AACzC;;AAEA,qEAAqE;AACrE;;EAEE,2BAA2B;AAC7B;;;AAGA;;8BAE8B;;AAE9B;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* =========================\n   HOW IT WORKS (overwrite)\n   - Left cards + right screenshot share EXACT aspect ratio\n   - Right dots hang below (don’t affect bottom alignment)\n   - Floating preview follows scroll (JS controls transform)\n   ========================= */\n\n.hiw {\n  background-image: radial-gradient(circle at 1px 1px, rgba(95, 186, 139, 0.14) 1px, transparent 0);\n    background-color: rgba(24, 21, 20, 1);\n  background-size: 28px 28px;\n  width: 100%;\n  padding: 96px 0;\n}\n\n.hiw__container {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.hiw__header {\n  margin-bottom: 40px;\n}\n\n.hiw__kicker {\n  font-size: 12px;\n  letter-spacing: 0.18em;\n  font-weight: 700;\n  opacity: 0.65;\n}\n\n.hiw__title {\n  margin: 10px 0 0 0;\n  font-size: 48px;\n  line-height: 1.05;\n  font-weight: 800;\n}\n\n.hiw__subtitle {\n  margin: 10px 0 0 0;\n  font-size: 18px;\n  line-height: 1.5;\n  opacity: 0.75;\n  max-width: 680px;\n}\n\n/* equal columns */\n.hiw__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 56px;\n  align-items: start;\n}\n\n/* -------------------------\n   LEFT (3 stacked steps)\n   ------------------------- */\n\n.hiw__left {\n  position: relative;\n}\n\n.hiw__rail {\n  position: absolute;\n  left: 18px;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: rgba(0, 0, 0, 0.12);\n}\n\n.hiw__steps {\n  display: flex;\n  flex-direction: column;\n  gap: 44px;\n}\n\n/* IMPORTANT: matches the right screenshot's aspect ratio */\n.hiw__step {\n  position: relative;\n  width: 100%;\n  aspect-ratio: var(--hiw-aspect, 16 / 10);\n\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: blur(10px);\n  border-radius: 28px;\n  padding: 32px;\n\n  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.10);\n  transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.hiw__step--active {\n  border-color: rgba(95, 186, 139, 0.45);\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.14);\n  transform: translateY(-2px);\n}\n\n.hiw__dot {\n  position: absolute;\n  left: 12px;\n  top: 38px;\n  width: 12px;\n  height: 12px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.20);\n}\n\n.hiw__dot--on {\n  background: rgba(95, 186, 139, 1);\n}\n\n.hiw__topline {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.hiw__num {\n  font-size: 12px;\n  letter-spacing: 0.18em;\n  font-weight: 800;\n  opacity: 0.7;\n}\n\n.hiw__line {\n  height: 1px;\n  flex: 1;\n  background: rgba(0, 0, 0, 0.10);\n}\n\n.hiw__stepTitle {\n  margin: 14px 0 0 0;\n  font-size: 34px;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.hiw__stepBody {\n  margin: 14px 0 0 0;\n  font-size: 16px;\n  line-height: 1.7;\n  opacity: 0.78;\n\n  /* pins buttons to bottom and prevents layout jump */\n  flex: 1;\n  overflow: hidden; /* change to auto if you want internal scroll */\n}\n\n.hiw__nav {\n  margin-top: 18px;\n  display: flex;\n  gap: 10px;\n}\n\n.hiw__btn {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  background: rgba(255, 255, 255, 0.65);\n  padding: 10px 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 150ms ease;\n}\n\n.hiw__btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n/* -------------------------\n   RIGHT (floating preview)\n   ------------------------- */\n\n.hiw__right {\n  position: relative; /* track for floater */\n  align-self: stretch;\n  min-height: 100%;\n}\n\n.hiw__floater {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n\n  will-change: transform;\n  transform: translate3d(0, 0, 0);\n\n  /* allow dots to hang below */\n  overflow: visible;\n}\n\n.hiw__previewWrap {\n  position: relative;\n}\n\n.hiw__frame {\n  width: 100%;\n  aspect-ratio: var(--hiw-aspect, 16 / 10);\n\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 28px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 26px 90px rgba(0, 0, 0, 0.14);\n}\n\n.hiw__imgStage {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.hiw__img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: contain;\n}\n\n/* crossfade stack */\n.hiw__imgFade {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  transition: opacity 500ms ease;\n}\n\n.hiw__imgFade--on {\n  opacity: 1;\n}\n\n/* dots do NOT affect frame height */\n.hiw__dots{\n  position: absolute;\n  left: 0;\n  right: 0;\n\n  top: auto;              /* override */\n  bottom: -26px;          /* <-- pushes dots below the frame bottom edge */\n  margin: 0;              /* override */\n\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n\n  pointer-events: auto;\n}\n\n\n.hiw__dotBtn {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  border: none;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.hiw__dotBtn--on {\n  background: rgba(95, 186, 139, 1);\n}\n\n.darkWrap{\n  --darkT: 0; /* 0 -> 1 */\n  /* base colors */\n  --from: 252, 249, 248;\n  --to: 24, 21, 20;\n\n  /* mix channels in CSS (supported in modern browsers) */\n  --r: calc((1 - var(--darkT)) * 252 + var(--darkT) * 24);\n  --g: calc((1 - var(--darkT)) * 249 + var(--darkT) * 21);\n  --b: calc((1 - var(--darkT)) * 248 + var(--darkT) * 20);\n\n  --bg: rgb(var(--r), var(--g), var(--b));\n}\n\n/* Apply same background to BOTH sections so the seam never appears */\n.darkWrap .fadeSection,\n.darkWrap .darkSection{\n  background-color: var(--bg);\n}\n\n\n/* -------------------------\n   Mobile\n   ------------------------- */\n\n@media (max-width: 900px) {\n  .hiw__grid {\n    grid-template-columns: 1fr;\n    gap: 28px;\n  }\n\n  .hiw__right {\n    display: none;\n  }\n\n  .hiw__rail,\n  .hiw__dot {\n    display: none;\n  }\n\n  .hiw__step {\n    aspect-ratio: auto;\n  }\n\n  .hiw__stepBody {\n    overflow: visible;\n  }\n\n  .hiw__title {\n    font-size: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
